The status of the position opening.

Currently, three codes are defined:

- `Incomplete` indicates the position opening is in a draft state.
- `Active` indicates the position opening is open.
- `Closed` indicates the position opening has been closed.
